import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function routeReducer(state = initialState.route, action) {
    switch (action.type) {
        case types.CREATE_ROUTE_SUCCESS: 
            return [...state, { ...action.route }];
        case types.UPDATE_ROUTE_SUCCESS:
            //return state.map(route => route.routeId === action.route.routeId ? action.route : route);
            return action.route;
        case types.LOAD_ROUTE_SUCCESS:
            return action.route; 
        case types.DELETE_ROUTE:
            return initialState.route;
        case types.ADD_BOOKMARK_OPTIMISTIC:
            return action.route; 
        case types.REMOVE_BOOKMARK_OPTIMISTIC:
            return action.route;
        case types.CLEAR_ROUTE:
            return initialState.route;
        case types.SHARE_ROUTE:
            state.associatedGroups.push({ routeId: action.route, groupId: action.group.id, groupName: action.group.name, avatarAvailable: action.group.avatarAvailable })
            return state; 
        case types.REMOVE_ROUTE_SHARE_OPTIMISTIC:
            return state;
        case types.REACT_ROUTE:
            let reactArray = [];
            state.userReactions.users.map(u => {
                reactArray.push(u)
            })
            reactArray.push(action.reaction);
            state.userReactions.users = reactArray; 
            return {
                ...state,
                userReactions: state.userReactions
            };;
        case types.UNREACT_ROUTE:
            let unreactArray = [];
            state.userReactions.users.map(u => {
                if (u.userId.toUpperCase() != action.reaction.userId.toUpperCase()) {
                    unreactArray.push(u)
                }
            })
            state.userReactions.users = unreactArray; 
            return {
                ...state,
                userReactions: state.userReactions
            };
        case types.CHANGE_REACTION_ROUTE:
            let changeReactArray = [];
            state.userReactions.users.map(u => {
                if (u.userId.toUpperCase() != action.reaction.userId.toUpperCase()) {
                    changeReactArray.push(u)
                }
                else {
                    changeReactArray.push(action.reaction)
                }
            })
            state.userReactions.users = changeReactArray;
            return {
                ...state,
                userReactions: state.userReactions
            };
        //case types.LOGOUT_SUCCESS:
        //    return initialState.route;
        default:
            return state; 
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/routeReducer.js